import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { concatMap, delay, retryWhen } from 'rxjs/operators';

@Injectable()
export class RetryRateLimitedRequestsInterceptor implements HttpInterceptor {
  maxRetry = 3;
  retryWaitMilliSeconds = 1000;
  retryCodes = [429, 408, 500, 502, 503, 504];

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retryWhen((error) =>
        error.pipe(
          concatMap((error2, count) => {
            if (count <= this.maxRetry && this.retryCodes.includes(error2.status)) {
              return of(error2);
            }
            return throwError(error2);
          }),
          delay(this.retryWaitMilliSeconds)
        )
      )
    );
  }
}
